(() => {
  const node = document.getElementById('ma-ad-market-context');
  if (!node) return;
  const context = JSON.parse(node.textContent);
  const imageCopy = {
    nl: {name:'Élodie jas van imitatiebont', views:{hero:'vooraanzicht',side:'zijaanzicht',back:'achteraanzicht',detail:'detail','three-quarter view':'driekwartaanzicht'}},
    sk: {name:'Élodie bunda z umelej kožušiny', views:{hero:'pohľad spredu',side:'pohľad zboku',back:'pohľad zozadu',detail:'detail','three-quarter view':'trojštvrťový pohľad'}},
    pl: {name:'Élodie kurtka ze sztucznego futra', views:{hero:'widok z przodu',side:'widok z boku',back:'widok z tyłu',detail:'detal','three-quarter view':'widok pod kątem'}}
  }[context.language];
  if (imageCopy) document.querySelectorAll('img[alt^="Élodie faux-fur"]').forEach(image=>{
    const match=image.alt.match(/(?: — | in )([A-Za-z]+), (.+)$/);
    if (match && imageCopy.views[match[2]]) image.alt=imageCopy.name+' — '+match[1]+', '+imageCopy.views[match[2]];
  });
  const url = new URL(location.href);
  const pair = {NL:'nl',SK:'sk',PL:'pl',AL:'sq'};
  const requested = url.searchParams.get('country');
  const isAd = url.searchParams.get('ma_ad') === 'elodie' || url.searchParams.has('fbclid') || /instagram|facebook|meta/i.test(url.searchParams.get('utm_source') || '');
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || event.ctrlKey || event.metaKey || link.hasAttribute('download')) return;
    const target = new URL(link.href,location.href);
    if (target.origin === location.origin && target.pathname === '/cart') target.pathname=context.preview ? '/cart' : '/' + context.language + '/cart';
    if (target.origin !== location.origin) return;
    if (!/^\/(nl|sk|pl|sq)\/(collections|products|cart)(\/|$)/.test(target.pathname) && !(context.preview && /^\/(collections|products|cart)(\/|$)/.test(target.pathname))) return;
    if (requested && pair[requested]) target.searchParams.set('country',requested);
    else target.searchParams.set('country',context.country);
    if (isAd) target.searchParams.set('ma_ad','elodie');
    if (context.preview) {target.searchParams.set('view',url.searchParams.get('view'));target.searchParams.set('preview_theme_id',context.theme_id);}
    link.href=target.pathname+target.search+target.hash;
  },{capture:true});
  if (isAd && location.pathname.endsWith('/collections/fur-coats')) {
    const navigation = performance.getEntriesByType('navigation')[0];
    if (navigation?.type !== 'back_forward') {
      if (['nl','sk','pl'].includes(context.language)) {
        const previousRestoration = history.scrollRestoration;
        history.scrollRestoration = 'manual';
        if (url.hash) {url.hash='';history.replaceState(history.state,'',url);}
        let interacted = false;
        const events = ['pointerdown','touchstart','wheel','keydown'];
        const stop = () => { interacted=true; events.forEach(name=>window.removeEventListener(name,stop)); history.scrollRestoration=previousRestoration; };
        events.forEach(name=>window.addEventListener(name,stop,{once:true,passive:true}));
        const top = () => {if (!interacted) window.scrollTo({top:0,left:0,behavior:'instant'});};
        const finish = () => requestAnimationFrame(()=>requestAnimationFrame(()=>{top();history.scrollRestoration=previousRestoration;}));
        top(); requestAnimationFrame(top);
        if (document.readyState === 'complete') finish(); else window.addEventListener('load',finish,{once:true});
        document.fonts?.ready.then(top);
        window.addEventListener('pagehide',stop,{once:true});
      } else {
      history.scrollRestoration='manual';
      if (url.hash) {url.hash='';history.replaceState(history.state,'',url);}
      const top = () => window.scrollTo({top:0,left:0,behavior:'instant'});
      top(); window.addEventListener('load',top,{once:true});
      requestAnimationFrame(top);
      }
    }
  }
  if (context.preview) {
    if (['sk','sq'].includes(context.language) && context.currency !== 'EUR' && context.available.includes('NL') && !sessionStorage.getItem('ma-clean-preview-eur:'+location.pathname)) {
      sessionStorage.setItem('ma-clean-preview-eur:'+location.pathname,'1');
      const previewForm=document.createElement('form');previewForm.method='POST';previewForm.action='/localization';
      const previewFields={form_type:'localization',_method:'put',country_code:'NL',language_code:context.language==='sk'?'en':context.language,return_to:url.pathname+url.search};
      for(const [name,value] of Object.entries(previewFields)){const input=document.createElement('input');input.type='hidden';input.name=name;input.value=value;previewForm.append(input);}document.body.append(previewForm);previewForm.submit();return;
    }
    const lock=()=>document.querySelectorAll('button[name="add"],sticky-add-to-cart button,button[type="submit"][name="checkout"]').forEach(b=>b.disabled=true);
    lock();document.addEventListener('DOMContentLoaded',lock,{once:true});return;
  }
  if (requested && pair[requested] && !context.available.includes(requested)) {
    const notice = document.createElement('p');
    notice.setAttribute('role','alert');
    notice.style.cssText='padding:18px 22px;background:#f7f5f2;color:#211d1a;font-size:13px';
    notice.textContent = context.message;
    document.querySelector('main')?.prepend(notice);
    document.querySelectorAll('button[name="add"]').forEach(button => {button.disabled = true;});
    return;
  }
  if (requested && pair[requested] && context.country !== requested) {
    const key = 'ma-market-attempt:' + requested + ':' + context.language;
    if (sessionStorage.getItem(key) === location.pathname) {
      const notice = document.createElement('p');notice.setAttribute('role','alert');notice.textContent=context.message;
      document.querySelector('main')?.prepend(notice);
      document.querySelectorAll('button[name="add"]').forEach(button=>{button.disabled=true;});return;
    }
    sessionStorage.setItem(key, location.pathname);
    const form = document.createElement('form');
    form.method='POST'; form.action='/localization';
    const fields = {form_type:'localization',_method:'put',country_code:requested,language_code:context.language,return_to:url.pathname+url.search};
    for (const [name,value] of Object.entries(fields)) {const input=document.createElement('input');input.type='hidden';input.name=name;input.value=value;form.append(input);}
    document.body.append(form);form.submit();return;
  }


})();
